// ============================================================================
// Redirect validation utilities
// Prevents open-redirect attacks via ?redirect= query parameters.
// ============================================================================

/**
 * Check whether a redirect URL is safe to follow.
 *
 * A safe redirect:
 *   - is a relative path starting with `/`
 *   - does not contain `//` (blocks protocol-relative and absolute URLs)
 *
 * @param url - The candidate redirect URL
 * @returns `true` if the URL is safe, otherwise `false`
 */
export function isSafeRedirect(url: string): boolean {
  return (
    typeof url === 'string' &&
    url.length > 0 &&
    url.startsWith('/') &&
    !url.includes('//')
  );
}
